function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M0 0C465.333 70.5883 770.667 105.882 916 105.882C1061.33 105.882 1236 100.092 1440 88.5111V1440H0V0Z",
  fill: "url(#paint0_linear)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 740.966,
  y1: 1521.19,
  x2: 740.966,
  y2: 42.3602,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#EDFCFF"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 1440,
  height: 107,
  fill: "white"
})));

var SvgHowItWorksTop = function SvgHowItWorksTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 1440 107",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHowItWorksTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/how-it-works-top.34ee8751.svg";
export { ForwardRef as ReactComponent };